import React from 'react';
import { useTranslate } from '../../../lib';
import { InputNesting } from '../../common/Inputs/Input';
import { SelectNesting } from '../../common/Inputs/Select';
import ButtonYesNo from '../../common/ButtonYesNo';
import BoxInfo from '../../common/BoxInfo'
import ClosingMessage from './ClosingMessage';

export default function VoiceSettings({
  showCallSettings,
  setTranscription,
  transcription,
  channel,
  phrases_list_ref,
  setPhrasesList,
  phrasesList,
  setHold,
  hold,
  timeHoldAmountRef,
  timeHoldRef,
  minimunCallDurations,
  maximunCallDurations,
  showClosing,
  closing_mesageRef,
  changeMaxCallDuration,
  sentimentBotRef,
  saveBotSentimentConfig,
  selectedProject,
  modelSentiment_ref,
  showVoicesSetting,
  setShowVoicesSetting,
  setRadomVoice,
  radomVoice,
  voice_ref,
  voices,
  textToPlay,
  setTextToPlay,
  playVoice,
}) {
  const { t } = useTranslate();

  return (
    <>
      {/* ENCABEZADO */}
      <div
        className='d-flex flex-row align-items-center justify-content-between w-100 mt-1 shadow_box'
        style={{
          backgroundColor: '#0088ff09',
          padding: 10,
          borderRadius: '10px 10px 0 0',
        }}
      >
        <div className='d-flex flex-row align-items-center w-100'>
          <div
            className='w-100'
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <h2 onClick={() => setShowVoicesSetting(!showVoicesSetting)} style={{ color: '#0B5FA3', fontSize: 15, cursor: "pointer" }} className='m-0'>
              {t('menu.genai.voicesSettings')}
            </h2>

            {!showVoicesSetting && (
              <button type='button' className='ml-3' onClick={() => setShowVoicesSetting(true)}>
                <img src='/icons/arrow_down.png' alt='' style={{ width: 15 }} />
              </button>
            )}

            {showVoicesSetting && (
              <button type='button' className='ml-3' onClick={() => setShowVoicesSetting(false)}>
                <img src='/icons/arrow_up.png' alt='' style={{ width: 15 }} />
              </button>
            )}
          </div>
        </div>
      </div>

      {/* CONTENIDO DESPLEGABLE */}
      <div
        style={{
          display: showVoicesSetting ? 'flex' : 'none',
          backgroundColor: '#0088ff09',
          padding: '5px 10px 10px 10px',
          position: 'relative'
        }}
        className='flex-column w-100'
      >
        <div className='d-flex flex-row flex-wrap pb-4 mt-1'>
          <div className="inputs pb-1">
            <div className="input d-flex flex-row align-items-center">
              <span style={{ minWidth: 140, whiteSpace: 'nowrap' }}>{t('menu.genai.transcriptionEnable')}:</span>
              <div style={{ marginLeft: 10 }} className="list_call_type d-flex flex-row align-items-center">
                <ButtonYesNo
                  onClick={() => setTranscription((prev) => prev == 0 ? 1 : 0)}
                  width={180}
                  state={transcription}
                  height={30}
                  Yes={t('common.true')}
                  No={t('common.false')}
                />
              </div>
            </div>
          </div>

          {channel === 'voice' &&
            <div className='d-flex flex-row items-center w-100'>
              <BoxInfo
                id="phraseslist"
                titleClass='w-100'
                title={t('menu.genai.phrasesList')}
                place="top"
                containerClass='mr-0-5'
                content={t('menu.genai.phrasesListTooltip')}
              />

              <div className="flex flex-col items-center">
                <div className="flex flex-row items-center">
                  <input
                    type="text" style={{ width: '20%', minWidth: 300, fontSize: 14 }}
                    className="flex-1 input-data mt-5"
                    placeholder={t('menu.genai.typePhraseEnter')}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && e.target.value.trim()) {
                        e.preventDefault();
                        const currentPhrases = phrases_list_ref.current.value
                          ? phrases_list_ref.current.value.split(';').filter(p => p.trim())
                          : [];
                        const newPhrase = e.target.value.trim();

                        if (!currentPhrases.includes(newPhrase)) {
                          const updatedPhrases = [...currentPhrases, newPhrase];
                          phrases_list_ref.current.value = updatedPhrases.join(';');
                          //console.log("ref current", phrases_list_ref.current.value)
                          setPhrasesList(updatedPhrases.join(';'));

                        }
                        e.target.value = '';
                      }
                    }}
                  />
                </div>

                <div className="flex flex-row flex-wrap gap-3 mb-4">
                  {phrasesList.split(';')
                    .filter(phrase => phrase.trim())
                    .map((phrase, index) => (
                      <div
                        key={`phraselist ${index + 1}:`}
                        className="flex items-center gap-2 px-4 py-2 rounded-full shadow-sm"
                        style={{
                          borderWidth: '2px',
                          padding: '5px',
                          margin: '5px',
                          borderColor: '#0087ff',
                          borderRadius: '50px'
                        }}
                      >
                        <span className="text-gray-700">{phrase}</span>
                        <button
                          type="button"
                          onClick={() => {
                            const currentPhrases = phrasesList.split(';').filter(p => p.trim());
                            const updatedPhrases = currentPhrases.filter((_, i) => i !== index);
                            //phrases_list_ref.current.value = updatedPhrases.join(';');
                            setPhrasesList(updatedPhrases.join(';'));
                          }}
                          className="p-1 hover:text-red-500 transition-colors duration-200"
                          style={{ marginLeft: '2px' }}
                        >
                          <img
                            src="/icons/trash-1.png"
                            alt="delete"
                            style={{ width: 16, height: 16 }}
                          />
                        </button>
                      </div>
                    ))}
                </div>

                <input
                  type="hidden"
                  ref={phrases_list_ref}
                  defaultValue={phrasesList}
                />
              </div>
            </div>
          }

          <div className='d-flex flex-row flex-wrap w-100 mt-1'>
            <div className="d-flex flex-row flex-wrap w-100" >
              <div className="input mr-2">
                <div className='flex flex-column' style={{ minWidth: 175 }}>
                  <BoxInfo
                    id="ramvoice-tp" titleClass='mr-0-4' styles={{ marginBottom: 10, whiteSpace: 'nowrap' }}
                    title={t('menu.genai.onHoldAvailability')}
                    place="top" containerClass='mr-0-5 '
                    content={t('menu.genai.onHoldAvailabilityTooltip')}
                  />
                  <ButtonYesNo
                    onClick={() => setHold((prev) => !prev)}
                    width={140}
                    state={hold}
                    height={30}
                  />
                </div>
              </div>

              <div className="mt-10px-mb flex flex-column mr-5">
                <InputNesting
                  containerClass="mb-3"
                  ref={timeHoldAmountRef} id="timeholdamount"
                  type="number"
                  disabled={!hold} style={{ maxWidth: 100 }}
                  title={t('menu.genai.holdAttempts')}
                />
              </div>
              <div className="mt-10px-mb flex flex-column mr-5">
                <InputNesting
                  ref={timeHoldRef} id="timehold"
                  type="number"
                  disabled={!hold}
                  containerClass="mt-5" style={{ maxWidth: 100 }}
                  title={t('menu.genai.holdTime')}
                />
              </div>
            </div>
          </div>

          <div className='d-flex flex-row flex-wrap w-100 mt-1'>
            <div className="d-flex flex-row flex-wrap w-100" >
              <div className="mt-10px-mb flex flex-column mr-5">
                <InputNesting
                  ref={minimunCallDurations} id="minimunCallDurations"
                  type="number" style={{ maxWidth: 100 }}
                  containerClass="mr-2 pb-0 mb-3"
                  title={t('menu.genai.minimunCallDurations')}
                />
              </div>
              <div className="mt-10px-mb flex flex-column mr-5">
                <InputNesting
                  ref={maximunCallDurations} id="maximunCallDurations"
                  type="number" style={{ maxWidth: 100 }}
                  containerClass="pb-0 mt-10px-mb"
                  title={t('menu.genai.maximunCallDurationsVoice')}
                  onChange={changeMaxCallDuration}
                />
              </div>            

              <div className="mt-10px-mb flex flex-column mr-5">
                {/* Closing Message (conditionally) */}
                <ClosingMessage
                    showClosing={showClosing}
                    closing_mesageRef={closing_mesageRef}
                />
              </div>
              
            </div>
          </div>

          <div className='mt-3 d-flex flex-row flex-wrap align-items-center w-100'>
            <SelectNesting
              ref={sentimentBotRef} id="bot_sentiment" onChange={saveBotSentimentConfig}
              boxInfo={true} tooltipText={t('menu.genai.botSentimentTooltip')}
              title={t('menu.genai.botSentiment')} containerClass="" style={{ minWidth: 150 }}
            >
              <option value="1" selected={selectedProject.bot_sentiment !== 0 ? 'selected' : ''}>{t('common.on')}</option>
              <option value="0" selected={selectedProject.bot_sentiment === 0 ? 'selected' : ''}>{t('common.off')}</option>
            </SelectNesting>
            <SelectNesting
              ref={modelSentiment_ref} id="model_sentiment"
              boxInfo={true} tooltipText={t('menu.genai.botSentimentTooltip')}
              title={t('menu.genai.modelSentiment')} containerClass="mt-10px-mb mr-2 ml-3" style={{ minWidth: 150 }}
            >
              <option key={`model0`} value={'Phrase'}>{t('common.phrase')}</option>
              <option key={`model1`} value={'Voice'}>{t('common.voice')}</option>
              <option key={`model2`} value={'Both'}>{t('common.bothPhraseVoice')}</option>
            </SelectNesting>
          </div>

          {channel === 'voice' &&
            <div className='mt-4 d-flex flex-row flex-wrap align-items-center w-100'>
              <div className="inputs">
                <div className="input">
                  <div className='d-flex flex-col  w-100 mr-3' style={{ alignItems: "center", flexDirection: "row" }}>
                    <BoxInfo
                      id="ramvoice-tp"
                      titleClass='mr-0-4'
                      title={`${t('menu.genai.randomVoices')}:`}
                      place="top"
                      containerClass='mr-0-5 '
                      content={t('menu.genai.randomVoicesTooltip')}
                    />
                    <ButtonYesNo
                      onClick={() => setRadomVoice((prev) => !prev)}
                      width={150}
                      state={radomVoice}
                      height={30}
                    />
                  </div>
                </div>
              </div>
              <SelectNesting
                ref={voice_ref} id="voice"
                boxInfo={true} tooltipText={t('menu.genai.selectVoiceTooltip')}
                title={`${t('menu.genai.selectVoice')}:`} containerClass="mt-10px-mb ml-2" style={{ minWidth: 150 }}
              >  {voices.map((item, index) => (<option key={`voice ${index + 1}:`} value={item.id}>{item.voice}</option>))}
              </SelectNesting>
              <input
                type="text"
                className="input-data mt-2"
                style={{ minWidth: 250, maxWidth: 400 }}
                placeholder="Write the text to be played"
                value={textToPlay}
                onChange={e => setTextToPlay(e.target.value)}
              />
              <button className="btn-nesting ml-2 mr-2 mt-2" type="button" onClick={() => { playVoice() }}> {t('common.play')} </button>
            </div>
          }

        </div>
      </div>
    </>
  );
}
